export default {
	SEND_CONTRACT: 'Send Contract',
	SEND_APPENDIX: 'Send Appendix',
	ROLES: {
		EMPLOYEE: 'Employee',
		MANAGER: 'Hr',
	},
};
